class VanillaAccordion {
  constructor(boxSelector, triggerSelector, contentSelector) {
    this.boxes = document.querySelectorAll(boxSelector);
    this.triggerSelector = triggerSelector;
    this.contentSelector = contentSelector;

    if (this.boxes.length > 0) {
      this.init();
    }
  }

  init() {
    this.boxes.forEach((box) => {
      const trigger = box.querySelector(this.triggerSelector);
      const content = box.querySelector(this.contentSelector);

      if (trigger && content) {
        trigger.addEventListener("click", () =>
          this.toggleAccordion(box, content)
        );
      }
    });
  }

  toggleAccordion(box, content) {
    const isActive = box.classList.contains("active");

    // すべてのアコーディオンを閉じる
    this.boxes.forEach((b) => {
      b.classList.remove("active");
      const c = b.querySelector(this.contentSelector);
      if (c) {
        c.style.height = "0px";
      }
    });

    // クリックされたものが開いていた場合は閉じる
    if (isActive) return;

    // 高さを取得して適用
    const contentHeight = content.scrollHeight + "px";
    content.style.height = contentHeight;

    // `active` クラスを付与
    box.classList.add("active");
  }
}

export default VanillaAccordion;
